import { FormattingToolbar, FormattingToolbarController } from '@blocknote/react';
import Button from '@/components/atoms/Button/Button';

export default function BlogPostGenerateClipToolbar({
  generateClipFromText,
  isGeneratingClip
}: {
  generateClipFromText: () => void;
  isGeneratingClip: boolean;
}) {
  return (
    <FormattingToolbarController
      formattingToolbar={() => (
        <FormattingToolbar>
          <Button
            className="m-2"
            variation="filled"
            trackingId="create-clip-button"
            onClick={generateClipFromText}
            disabled={isGeneratingClip}
          >
            {isGeneratingClip ? ' Generating Clip...' : 'Generate and Add Clip'}
          </Button>
        </FormattingToolbar>
      )}
    />
  );
}
